import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const pastMedicalHistoryRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () =>
        import(
          "@pages/panelPages/patientPastMedicalHistoryList/patientPastMedicalHistoryList"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.past-medical-history",
            [],
            "edit",
            "main",
          );
        return {
          /* mode: 'view', id: params.id!*/
        };
      },
    },
    permissions: ["doctor", "patient", "staff"],
  },
  {
    route: {
      path: path.view.route,
      lazy: () =>
        import("@pages/panelPages/pastMedicalHistory/pastMedicalHistory"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.past-medical-history", [], "edit");
        return {
          /* mode: 'view', id: params.id!*/
        };
      },
    },
    permissions: ["doctor", "patient", "staff"],
  },
  {
    route: {
      path: path.viewPatient.route,
      lazy: () =>
        import("@pages/panelPages/pastMedicalHistory/pastMedicalHistory"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.past-medical-history", [], "edit");
        return {
          /* mode: 'view', id: params.id!*/
        };
      },
    },
    permissions: ["doctor", "patient", "staff"],
  },
];
